import {useEffect} from 'react';
import GoStreaksBar from '../GoStreaksBar/GoStreaksBar';
import {stringReplaceWithJsx} from '@stencil/hotels-utils/src/common-utils';
import HappyGoStayLogoNew from '@stencil/icons/src/HappyGoStayLogoNew/HappyGoStayLogoNew';
import HappyAngleRightIcon from '@stencil/icons/src/HappyAngleRightIcon/HappyAngleRightIcon';
import {StreaksInfo} from '@stencil/hotels-types/src/hotels-review-types';
import {gaConfig} from '@stencil/hotels-config';
import {pushga} from '@stencil/ga-utils';

import * as S from './GoStreaksReview.styles';

const {mwebReviewPageGaEvents, goStreaksReview, ReviewGAEvents} = gaConfig;

interface GoStreaksReviewProps {
  streaksInfo: StreaksInfo;
  onGoStreaksClickCta?: () => void;
  isMweb?: boolean;
  isUnif?: boolean;
}

const GoStreakReview: React.FC<GoStreaksReviewProps> = ({
  streaksInfo,
  onGoStreaksClickCta,
  isMweb = false,
  isUnif = false,
}) => {
  useEffect(() => {
    if (!streaksInfo?.review?.show_tracker || !streaksInfo?.is_gostreaks_active) {
      return;
    }
    if (!isUnif) {
      pushga({
        event: isMweb ? mwebReviewPageGaEvents?.event : ReviewGAEvents?.category_reviewPageClicks,
        eventCategory: isMweb
          ? goStreaksReview?.eventCategory?.goStreaksMweb
          : goStreaksReview?.eventCategory?.goStreaksDweb,
        eventAction: goStreaksReview?.eventAction?.bannerViewed,
        eventLabel: `c_${streaksInfo?.completed_bookings}|p_${
          streaksInfo?.in_progress_bookings || 0
        }`,
      });
    }
  }, [streaksInfo?.review?.show_tracker]);

  const onGoStreaksClick = () => {
    if (!isUnif) {
      pushga({
        event: isMweb ? mwebReviewPageGaEvents?.event : ReviewGAEvents?.category_reviewPageClicks,
        eventCategory: isMweb
          ? goStreaksReview?.eventCategory?.goStreaksMweb
          : goStreaksReview?.eventCategory?.goStreaksDweb,
        eventAction: goStreaksReview?.eventAction?.bannerClicked,
      });
    }
    if (onGoStreaksClickCta) {
      onGoStreaksClickCta();
    }
  };

  return streaksInfo?.review?.show_tracker && streaksInfo?.is_gostreaks_active ? (
    <S.GoStreakReviewWrapper onClick={onGoStreaksClick} isMweb={isMweb}>
      <S.GoStreakDetailsHeaderWrapper>
        <p className="headerText">
          {stringReplaceWithJsx(
            streaksInfo?.review?.message,
            '<go_stays_icon>',
            <HappyGoStayLogoNew margin="0.8rem 0.6rem 0" />,
          )}
        </p>
      </S.GoStreakDetailsHeaderWrapper>
      <S.GoStreakDetailsContentWrapper isMweb={isMweb}>
        <S.GoStreakDetailsContenInnerWrapper isMweb={isMweb}>
          <div className="rightWrapper">
            <p className="headerText">{streaksInfo?.review?.title}</p>
            <p className="descText">{streaksInfo?.review?.subtitle}</p>
          </div>
          {!isMweb && (
            <div className="rightWrapper">
              <HappyAngleRightIcon
                width="1rem"
                height="1rem"
                margin="0 0 0 0.6rem"
                fill="#222B45;"
              />
            </div>
          )}
        </S.GoStreakDetailsContenInnerWrapper>

        <GoStreaksBar
          completedBookings={streaksInfo?.completed_bookings || 0}
          inProgressBookings={streaksInfo?.in_progress_bookings || 0}
          showTracker={streaksInfo?.review?.show_tracker}
          maxBookings={streaksInfo?.max_bookings}
        />
      </S.GoStreakDetailsContentWrapper>
    </S.GoStreakReviewWrapper>
  ) : null;
};

export default GoStreakReview;
